import { render, staticRenderFns } from "./saved-charts.vue?vue&type=template&id=5272d646&"
import script from "./saved-charts.vue?vue&type=script&lang=js&"
export * from "./saved-charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports